module.exports = {
    kolmatTitle: "网红营销",
    dashboard:'大盘分析',
    dashboard2:'进度追踪',
    report:'明细报告',
    reportResult: '结案报告',
    setting:'设置',
    kolSettingBasicData: '基本数据',
    kolMktSettingReportResult: '结案报告',
    cpmTrendsInLast7Days: '过去 7 天的浏览量趋势',
    dimension: '维度数据',
    index: '指标数据',
    influencer: '网红',
    campaign: '产品',
    campaigns:'营销活动',
    source:'来源',
    platform: '平台',
    launchInTime: '发布时间',
    viewCounts: '浏览量',
    cpm: '千次付费',
    product:'产品',
    nearyear:'近7天的浏览量',
    affcost:'Aff花费',
    samelinkdd:'相同的视频链接下的日期不能重复，请重新设置',
    noadd:'数据没有被填写完成，无法创建新数据',
    vcr:'视频链接不能重复',
    profit:'利润',
    profitlv:'利润率',
    kolTop5Campaigns: 'TOP5网红统计指标分布',
    enterAdvertiser: '请输入广告主',
    enterCorAdv:'请输入正确的广告主',
    pldele:'请选择广告主数据进行删除',
    enterInfluencer: '请输入网红名称',
    enterCampaign: '请输入产品名称',
    enterPlatform: '请输入平台名称',
    kolTrackSettingProduct:'产品维护',
    kolTrackSettingMarketing:'项目维护',
    kolmustone:'至少选择一个网红',
    kolMktSettingKolUpload:'网红上传',
    startLuanch:'开始发布',
    entryDate:'录入日期',
    logo:'头像',
    kolname:'KOL名称',
    channel:'渠道来源',
    state:'状态',
    kollink:'网红链接',
    reportPrice:'上报价格',
    bloggerPrice:'参考成本价格',
    othercontent:'其他联系方式',
    mp:'MP',
    progress:'开发进展',
    lunch:'发布状态',
    Unpublished:'未发布',
    Publishing:'发布中',
    Published:'已发布',
    Publishingfailed:'发布失败',
    competingProducts:'竞品',
    kolType:'博主类型',
    quotedVideoType:'视频类型',
    introduce:'推荐理由',
    promotionCase:'推广案例',
    KOLQU:'网红报价信息',
    KOLbasice:'网红基础信息',
    priceInfo:'价格信息',
    baiceInfo:'基本信息',
    promoteInfo:'推进信息',
    notget:'暂未获取KOL相关数据',
    lengths:'长度应该在',
    to:'至',
    betwwen:'位之间',
    male:'男',
    female:'女',
    exportIn:'导入网红',
    dfile:'网红模板',
    lunchSure:'确定发布吗？',
    downfail:'下载失败',
    EMPTYS:'上传内容为空',
    linknone:'网红信息链接不能为空',
    kolmkthave:'网红连接已存在',
    pleasechange:'请修改后重新上传!',
    linkempty:'网红连接不能为空,请检查您的文件内容！',
    ti1:'请填写网红链接',
    ti2:'不是一个正确的链接形式',
    ti3:'链接渠道不正确',
    ti4:'链接渠道内容缺少模块类型',
    ti5:'链接渠道内容缺少网红id',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/kolmkt/zh-cn.js